<script lang="ts" setup>
import type { CrossSectionType } from '@/stores/type/crossSection.type'
import type { PropType } from 'vue'
import BaseCrossSectionDataTable from '@/components/calculation-result/BaseCrossSectionDataTable.vue'
import { storeToRefs } from 'pinia'
import { useCalculationStore } from '@/stores/calculation.ts'

const props = defineProps({
  item: { type: Object as PropType<CrossSectionType>, required: true }
})

const { currentItem } = storeToRefs(useCalculationStore())

const tableRowFields: (keyof CrossSectionType | null)[] = [
  'cost_gabion',
  'cost_filter_unit',
  'cost_rock_layer',
  'cost_blockmat',
  'cost_block',
  'cost_mattress',
  'cost_insitu_filled_mattress'
]
</script>

<template>
  <BaseCrossSectionDataTable
    :item="item"
    table-header="Costs"
    :table-row-fields="tableRowFields"
    :unit="currentItem?.currency"
  />
</template>
